"use client";

import React, { useState, useEffect } from "react";
import { Menu, X, Globe, User } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { CartIcon } from "@/components/shop/CartIcon";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Separator } from "@/components/ui/separator";
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
const NestedList = ({
  items,
  level = 1
}: {
  items: any[];
  level?: number;
}) => {
  if (!items || items.length === 0) return null;
  return <ul className={cn("flex flex-col gap-3 py-2", level > 1 ? "pl-6" : "pl-0")}>
      {items.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="group flex items-start gap-2 font-sans text-sm text-muted-foreground transition-colors hover:text-primary">
            <span className="mt-0.5 text-primary/40 group-hover:text-primary/80">
              {level === 1 ? "•" : "◦"}
            </span>
            <span>{item.label}</span>
          </Link>
          {item.children && item.children.length > 0 && <div className="mt-2">
              <NestedList items={item.children} level={level + 1} />
            </div>}
        </li>)}
    </ul>;
};
function HeaderContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileMenuOpen]);
  return <>
      {}
      {isMobileMenuOpen && <div className="fixed inset-0 z-[100] flex flex-col bg-background md:hidden">
          <div className="flex h-16 items-center justify-end border-b border-border px-4">
            <Button variant="ghost" size="icon" onClick={() => setIsMobileMenuOpen(false)} className="text-foreground hover:text-primary hover:bg-accent rounded-full">
              <X className="size-6" />
              <span className="sr-only">Close Menu</span>
            </Button>
          </div>

          <ScrollArea className="flex-1 px-4 py-6">
            <div className="flex flex-col gap-6">
              {loading ? <div className="flex flex-col gap-4">
                  {[1, 2, 3, 4, 5].map((_, i) => <div key={`mob-skel-${i}`} data-index={i} className="h-8 w-40 animate-pulse bg-muted rounded-full" />)}
                </div> : <ul className="flex flex-col gap-6">
                  {menuItems.map((item, i) => <li key={item.id} data-index={i} className="flex flex-col gap-3">
                      <Link to={item.href || "#"} onClick={() => setIsMobileMenuOpen(false)} className="font-sans text-2xl font-bold tracking-tight text-foreground transition-colors hover:text-primary">
                        <span className="mr-3 font-mono text-sm text-primary/40">
                          0{i + 1}
                        </span>
                        {item.label}
                      </Link>
                      {item.children && item.children.length > 0 && <div className="pl-6">
                          <NestedList items={item.children} />
                        </div>}
                    </li>)}
                </ul>}

              <Separator className="my-4 bg-border/50" />

              {}
              <div className="flex flex-col gap-4 font-sans text-base text-foreground/70">
                <div className="flex items-center gap-3 py-2 px-1 hover:text-primary transition-colors">
                  <Globe className="size-5 text-primary/60" />
                  <span>Language: English</span>
                </div>
                <div className="flex items-center gap-3 py-2 px-1 hover:text-primary transition-colors">
                  <User className="size-5 text-primary/60" />
                  <span>Client Login</span>
                </div>
              </div>
            </div>
          </ScrollArea>
        </div>}
    </>;
}
export default function PrimaryNavigationMenu() {
  return <section data-section-id="161661" id="our-vans" className="w-full bg-background text-foreground">
      <MenuProvider menu_id="98" className="w-full">
        <HeaderContent />
      </MenuProvider>
    </section>;
}